import { getSystemMaterials } from "@/api/spec-common/material";
import { MaterialCategory, MaterialCode, MaterialInLibrary, PMaterial } from "@/commons/interface/speccommon/material";
import { Input, message } from "antd";
import { useEffect, useImperativeHandle, useState } from "react";
import { ReactComponent as ArrowDownSvg } from "@/commons/icons/arrow/arrow-down-black.svg";
import { ParamNameUtil, ParamUnits } from "@/commons/utils/unit";
import ContextMenuWrapper from "@/commons/widget/context-menu/context-menu-wrapper";
import './material-selfdefine.less'

interface IProps {
    width: number;
    goBack: () => void
    onAddSelfdefine: (material: PMaterial) => void
}
export default function MaterialSelfdefine(props: IProps, ref) {
    const [matCategorys, setMatCategorys] = useState<MaterialCategory[]>([]);
    const [matCodes, setMatCodes] = useState<MaterialCode[]>([]);
    const [matMarks, setMatMarks] = useState<MaterialInLibrary[]>([]);
    const [selCategory, setSelCategory] = useState<MaterialCategory>(); // 当前材料类别
    const [selCode, setSelCode] = useState<MaterialCode>(); // 当前材料规范
    const [selMark, setSelMark] = useState<MaterialInLibrary>();

    const [categoryVisiable, setCategoryVisiable] = useState<boolean>(false); // 库导入分类的下拉框是否可见
    const [codeVisiable, setCodeVisiable] = useState<boolean>(false); // 库导入标准的下拉框是否可见
    const [markVisiable, setMarkVisiable] = useState<boolean>(false); // 库导入等级的下拉框是否可见
    const [newMaterial, setNewMaterial] = useState<PMaterial>(null);

    useImperativeHandle(ref, () => ({
        handleInsert: () => { props.onAddSelfdefine(newMaterial) },
    }))

    useEffect(() => {
        getSystemMaterials().then((res) => {
            let categorys: MaterialCategory[] = res.data || [];
            setMatCategorys(categorys);
            if (categorys.length > 0) {
                setSelCategory(categorys[0]);
                setMatCodes(categorys[0].codes || []);
                if ((categorys[0].codes || []).length > 0) {
                    setSelCode(categorys[0].codes[0]);
                    setMatMarks(categorys[0].codes[0].libraries || []);
                    if (categorys[0].codes[0].libraries.length > 0) {
                        setSelMark(categorys[0].codes[0].libraries[0]);
                    }
                }
            }
        })
    }, [])

    useEffect(() => {
        if (!selCategory) return;
        let categoryIdx = matCategorys.findIndex(item => item.id == selCategory.id);
        let matCodes = matCategorys[categoryIdx].codes;
        setMatCodes(matCodes);
        setSelCode(matCodes[0]);
        setMatMarks(matCodes[0].libraries);
        setSelMark(matCodes[0].libraries[0]);
        setNewMaterial({ ...newMaterial, category: selCategory.id, categoryName: selCategory.name, code: matCodes[0].code, mark: matCodes[0].libraries[0].mark, params: matCodes[0].libraries[0].params });
        setCategoryVisiable(false);
    }, [selCategory])

    useEffect(() => {
        if (!selCode) return;
        let categoryIdx = matCategorys.findIndex(item => item.id == selCategory.id);
        let codeIdx = matCodes.findIndex(item => item.id == selCode.id);
        let matMarks = matCategorys[categoryIdx].codes[codeIdx].libraries;
        setMatMarks(matMarks);
        setSelMark(matMarks[0]);
        setNewMaterial({ ...newMaterial, code: matCodes[0].code, mark: matCodes[0].libraries[0].mark, params: matCodes[0].libraries[0].params });
        setCodeVisiable(false);
    }, [selCode])

    useEffect(() => {
        if (!selMark) return;
        setNewMaterial({ ...newMaterial, mark: selMark.mark, params: selMark.params });
        setCodeVisiable(false);
    }, [selMark])

    const handleChangeParams = (key: string, value: string) => {
        const newValue = parseFloat(value);
        if (!isNaN(newValue)) {
            const updatedParams = { ...newMaterial.params, [key]: newValue };
            setNewMaterial({ ...newMaterial, params: updatedParams });
        } else if (value === "") {
            const newValue = 0;
            const updatedParams = { ...newMaterial.params, [key]: newValue };
            setNewMaterial({ ...newMaterial, params: updatedParams });
        } else {
            message.error("请输入正确的数值");
        }
    }

    return (
        <div className="material-selfdefine">
            <div className="common-box name-box">
                <div className="name-item">
                    <div className="name-item-title">名称</div>
                    <Input
                        placeholder="请输入名称"
                        value={newMaterial?.name || ""}
                        onChange={(e) => {
                            setNewMaterial({ ...newMaterial, name: e.target.value });
                        }}
                    ></Input>
                </div>
                <div className="name-item">
                    <div className="name-item-title">材料类型</div>
                    <ContextMenuWrapper
                        container={
                            <div className="select-content">
                                <div className="ellipsis">{selCategory?.name}</div>
                                <ArrowDownSvg
                                    style={{ marginLeft: "4px", flexShrink: 0 }}
                                />
                            </div>
                        }
                        visible={categoryVisiable}
                        onVisibleChange={(v) => setCategoryVisiable(v)}
                        classname="select-area"
                        width={props.width - 32 - 4}
                    >
                        <div className="project-material-select-box">
                            {matCategorys?.map((item, index) => {
                                return (
                                    <div
                                        key={item.id}
                                        onClick={() => setSelCategory(item)}
                                        className="project-material-select-box-item"
                                    >
                                        {item.name}
                                    </div>
                                );
                            })}
                        </div>
                    </ContextMenuWrapper>
                </div>
                <div className="name-item">
                    <div className="name-item-title">标准</div>
                    <ContextMenuWrapper
                        container={
                            <div className="select-content">
                                <div className="ellipsis">
                                    {selCode?.code}
                                </div>
                                <ArrowDownSvg
                                    style={{ marginLeft: "4px", flexShrink: 0 }}
                                />
                            </div>
                        }
                        visible={codeVisiable}
                        onVisibleChange={(v) => setCodeVisiable(v)}
                        classname="select-area"
                        width={props.width - 32 - 4}
                    >
                        <div className="project-material-select-box">
                            {matCodes.map((item, index) => {
                                return (
                                    <div
                                        key={item.id}
                                        onClick={() => setSelCode(item)}
                                        className="project-material-select-box-item"
                                    >
                                        {item.code}
                                    </div>
                                );
                            })}
                        </div>
                    </ContextMenuWrapper>
                </div>
                <div className="name-item">
                    <div className="name-item-title">
                        {selCategory?.name}等级
                    </div>
                    <ContextMenuWrapper
                        container={
                            <div className="select-content">
                                <div className="ellipsis">
                                    {selMark?.mark + (isNaN(selMark?.thickMin) ? "" : "-" + selMark?.thickMin) + (isNaN(selMark?.thickMax) ? "" : "-" + selMark?.thickMax)}
                                </div>
                                <ArrowDownSvg
                                    style={{ marginLeft: "4px", flexShrink: 0 }}
                                />
                            </div>
                        }
                        visible={markVisiable}
                        onVisibleChange={(v) => setMarkVisiable(v)}
                        classname="select-area"
                        width={props.width - 32 - 4}
                    >
                        <div className="project-material-select-box">
                            {matMarks.map(
                                (item, index) => {
                                    return (
                                        <div
                                            key={item.id}
                                            onClick={() => setSelMark(item)}
                                            className="project-material-select-box-item"
                                        >
                                            {item.mark + (isNaN(item?.thickMin) ? "" : "-" + item?.thickMin) + (isNaN(item?.thickMax) ? "" : "-" + item?.thickMax)}
                                        </div>
                                    );
                                }
                            )}
                        </div>
                    </ContextMenuWrapper>
                </div>
            </div>
            <div className="common-box param-box">
                <div className="param-box-title">材料参数</div>
                {newMaterial &&
                    Object.entries(newMaterial.params).filter(([param, value]) => { return (ParamNameUtil[param] != null) && (ParamUnits[param] != null) }).map(([param, value]) => (
                        <div className="param-item" key={param} >
                            <div className="param-item-title">
                                {ParamNameUtil[param] != null ? `${ParamNameUtil[param]}` : ""}
                                {ParamUnits[param] != null ? `(${ParamUnits[param]})` : ""}
                            </div>
                            <Input
                                placeholder={`请输入${ParamNameUtil[param]}`}
                                value={value || ""}
                                onChange={(e) => handleChangeParams(param, e.target.value)}
                            />
                        </div >
                    ))}
            </div >
            {/* < div className='footer' >
                <Button className='btn' onClick={() => props.onAddSelfdefine(newMaterial)}>添加22</Button>
                <Button className='btn cancel' onClick={() => props.goBack()}>取消</Button>
            </div > */}
            {/* <div className='bottom-footer'>
                <Button className='btn-save' onClick={() => props.onAddSelfdefine(newMaterial)}>添加</Button>
                <Button className='btn-cancel' onClick={() => props.goBack()}>取消</Button>
            </div> */}
        </div >
    )
}